import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import { createPinia } from 'pinia';
import LongzeVideoPlay from 'longze-vue3-video-player';
// import 'longze-vue3-video-player/dist/style.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
// import ElementPlus from 'element-plus';
// import 'element-plus/dist/index.css';
// import zhTw from 'element-plus/es/locale/lang/zh-tw';
import axios from 'axios';
import { useUserStore } from './store/useUserStore';
// 導入 WebSocket 配置
import './websocket-config';

import './assets/styles/main.css'

// 設置 WebSocket 連接地址
if (import.meta.env.DEV) {
  // 開發環境下，使用當前頁面的主機和端口
  window.__vite_ws_host = window.location.hostname;
  window.__vite_ws_port = window.location.port || (window.location.protocol === 'https:' ? '443' : '80');
  console.log(`開發模式：WebSocket 連接到 ${window.__vite_ws_host}:${window.__vite_ws_port}`);
}

// 在開發模式下不清除認證信息，保持跨系統同步
if (import.meta.env.DEV) {
  console.log('開發模式：保持跨系統認證狀態同步');
  // 不清除任何認證信息，讓跨系統同步正常工作
}

const app = createApp(App);
const pinia = createPinia();

app.use(pinia);

// 初始化用戶狀態
const userStore = useUserStore();
userStore.initializeFromStorage(); // 從 localStorage 恢復用戶狀態
userStore.setupCrossSystemSync(); // 設置跨系統同步

app.use(router);
app.use(LongzeVideoPlay);

// 動態設置 API base URL
// 檢測是否通過主系統的 /ordersong/ 路徑訪問
const isOrdersongPath = window.location.pathname.startsWith('/ordersong/') || 
                        window.location.hostname.includes('ordersong');
axios.defaults.baseURL = isOrdersongPath ? '/ordersong/api' : '/api';

// 設置超時時間
axios.defaults.timeout = 60000;  // 增加到 60 秒

// 設置請求攔截器
axios.interceptors.request.use(
  config => {
    // 確保所有 URL 都是相對路徑
    if (config.url) {
      // 檢查是否包含 127.0.0.1:8000
      if (config.url.includes('127.0.0.1:8000/api/')) {
        config.url = config.url.replace(/https?:\/\/127\.0\.0\.1:8000\/api\//, '/api/');
      }
      
      // 檢查是否包含 localhost:8000
      if (config.url.includes('localhost:8000/api/')) {
        config.url = config.url.replace(/https?:\/\/localhost:8000\/api\//, '/api/');
      }
      
      // 檢查是否包含 backend:8000
      if (config.url.includes('backend:8000/api/')) {
        config.url = config.url.replace(/https?:\/\/backend:8000\/api\//, '/api/');
      }
      
      // 處理 /music/api/ 路徑
      if (config.url.includes('/music/api/')) {
        config.url = config.url.replace('/music/api/', '/api/');
      }
    }
    
    // 首先確保 baseURL 正確設置（優先處理）
    const currentPath = window.location.pathname;
    const currentHost = window.location.hostname;
    const isOrdersongPath = currentPath.startsWith('/ordersong/') || currentHost.includes('ordersong');
    
    // 強制設置 baseURL（覆蓋任何現有設置）
    config.baseURL = isOrdersongPath ? '/ordersong/api' : '/api';
    
    console.log('API Request:', config.url);
    console.log('BaseURL:', config.baseURL);
    console.log('Full URL:', (config.baseURL || '') + (config.url || ''));
    console.log('Current Path:', currentPath);
    console.log('Current Host:', currentHost);
    console.log('Is Ordersong Path:', isOrdersongPath);
    return config;
  },
  error => {
    console.error('API Request Error:', error);
    return Promise.reject(error);
  }
);

// 設置響應攔截器
axios.interceptors.response.use(
  response => {
    return response;
  },
  error => {
    console.error('API Error:', error);
    // 提供更詳細的錯誤信息
    if (error.response) {
      // 服務器響應了錯誤狀態碼
      console.error('錯誤狀態碼:', error.response.status);
      console.error('錯誤詳情:', error.response.data);
      console.error('請求 URL:', error.config?.url);
    } else if (error.request) {
      // 請求已發送但沒有收到響應
      console.error('請求已發送但無響應，可能是網路問題或服務器未運行');
      console.error('請求 URL:', error.config?.url);
      if (error.code === 'ECONNABORTED') {
        console.error('請求超時:', error.message);
      }
    } else {
      // 其他錯誤
      console.error('錯誤詳情:', error.message);
    }
    return Promise.reject(error);
  }
);

// 將 axios 添加到 Vue 實例
app.config.globalProperties.$axios = axios;

// // app.use(ElementPlus, {
// //   locale: zhTw,
// // }
// );

app.mount('#app');
